/**
 * Feature flag (configured server-side as segment-backed by
 * `long_form_assessment_assessor_access`) that surfaces the DUPR App
 * "Administer Assessment" entry in the hamburger menu. Server-side start is the
 * authoritative gate; this only controls menu visibility.
 *
 * NOTE: the flag string value changed with the DUPR App rename; the remote-config
 * flag must be renamed to "DUPR_APP_ASSESSOR" in lockstep (kept in sync with the
 * server-side `DUPR_APP_ASSESSOR_FEATURE` in dupr-app-level.ts). The
 * `long_form_assessment_assessor_access` segment value is persisted and unchanged.
 */
export const DUPR_APP_ASSESSOR_FEATURE = "DUPR_APP_ASSESSOR";

/**
 * The padel (WPR) counterpart of {@link DUPR_APP_ASSESSOR_FEATURE}: surfaces
 * the "WPR Assessment" entry in the hamburger menu. Kept in sync with the
 * server-side `WPR_APP_ASSESSOR_FEATURE` in dupr-app-level.ts, which is the
 * authoritative gate on administering padel for another player.
 */
export const WPR_APP_ASSESSOR_FEATURE = "WPR_APP_ASSESSOR";

/**
 * Who works with assessments run on players' behalf (the Unclaimed Assessments
 * page and its menu entry): admins and either sport's assessors.
 */
export function isAssessmentAssessor(
    isAdmin: boolean,
    features: string[],
): boolean {
    return (
        isAdmin ||
        features.includes(DUPR_APP_ASSESSOR_FEATURE) ||
        features.includes(WPR_APP_ASSESSOR_FEATURE)
    );
}

/**
 * Legacy proxy-administer feature used by the standard assessment start dialog.
 * Shared here so the DUPR App and standard flows agree on the constant.
 */
export const ADMINISTER_ASSESSMENT_PROXY_FEATURE =
    "ADMINISTER_ASSESSMENT_PROXY";
